<!-- CONTAINER -->
<div class="container content-area relative">

  <!-- PAGE-HEADER -->
  <div class="page-header">
    <h4 class="page-title">Languages</h4>
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Language</li>
    </ol>
  </div>
  <!-- PAGE-HEADER END -->
  
  <!-- ROW-1 OPEN -->
 <div class="row" id="user-profile">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">

        <!-- Header with search & add -->
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <input
            type="text"
            placeholder="Type to filter languages..."
            class="form-control w-auto mb-2 mb-lg-0"
            style="min-width: 250px;"
            (keyup)="updateFilter($event)"
          />
          <button class="btn btn-outline-primary" (click)="open(content)">
            <i class="fa fa-plus mr-1"></i> Add Language
          </button>
        </div>

        <hr>

        <!-- Language Cards -->
        <div class="row">
          <div class="col-md-3 mb-3" *ngFor="let language of languageData">
            <div class="card h-100 shadow-sm">
              <div class="card-body text-center">
                <h5 class="mb-2">{{ language.name }}</h5>
                <a [routerLink]="['/admin/languages/editlanguage/', language._id]" class="text-muted small">
                  Edit
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Template -->
        <ng-template #content let-modal>
          <div class="modal-header">
            <h5 class="modal-title">Add New Language</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form [formGroup]="addLanguageForm" (ngSubmit)="onAddLanguage()">
            <div class="modal-body">
              <div class="form-group">
                <label for="language">Language</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="name"
                  placeholder="e.g. Hindi, English"
                />
                <div *ngIf="f.name.invalid && (f.name.dirty || f.name.touched)" class="text-danger mt-1">
                  Required
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" (click)="modal.close('Cancel')">Cancel</button>
              <button type="submit" class="btn btn-primary" [disabled]="!addLanguageForm.valid">Save</button>
            </div>
          </form>
        </ng-template>

      </div>
    </div>
  </div>
</div>

  <!-- CONTAINER CLOSED -->
